import { render, staticRenderFns } from "./video-collect.vue?vue&type=template&id=17e98bc1&scoped=true&"
import script from "./video-collect.vue?vue&type=script&lang=js&"
export * from "./video-collect.vue?vue&type=script&lang=js&"
import style0 from "./video-collect.vue?vue&type=style&index=0&id=17e98bc1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e98bc1",
  null
  
)

export default component.exports